<app-cards-generator [cardInput]="cardInput" [widgetRef]="widgetRef">
</app-cards-generator>
